import React, {useEffect, useRef, useState} from 'react';

interface TooltipProps {
    children: React.ReactNode;
    content: React.ReactNode;
}

export const Tooltip: React.FC<TooltipProps> = ({ children, content }) => {
    const [visible, setVisible] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const triggerRef = useRef<HTMLSpanElement>(null);
    const tooltipRef = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        if (visible && triggerRef.current && tooltipRef.current) {
            const triggerRect = triggerRef.current.getBoundingClientRect();
            const tooltipRect = tooltipRef.current.getBoundingClientRect();

            let top = triggerRect.bottom + 8;
            let left = triggerRect.right - tooltipRect.width;

            // Не вылезать за левый край
            if (left < 8) left = 8;
            // Не вылезать за правый край
            if (left + tooltipRect.width > window.innerWidth - 8) {
                left = window.innerWidth - tooltipRect.width - 8;
            }
            // Если не влезает снизу — показать сверху
            if (top + tooltipRect.height > window.innerHeight - 8) {
                top = triggerRect.top - tooltipRect.height - 8;
            }
            // Если не влезает сверху — показать снизу с краем
            if (top < 8) {
                top = 8;
            }

            setPosition({ top, left });
        }
    }, [visible, content]);

    return (
        <span
            ref={triggerRef}
            className='tooltip'
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => setVisible(false)}
        >
            {children}
            {visible && (
                <span
                    ref={tooltipRef}
                    className='tooltip__content'
                    style={{
                        position: 'fixed',
                        top: position.top,
                        left: position.left,
                    }}
                >
                    {content}
                </span>
            )}
        </span>
    );
};